import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BrochureService {
  private openSignal = new Subject<void>();
  open$ = this.openSignal.asObservable();

  open() { this.openSignal.next(); }
}
